import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import * as React from "react";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { EditorialModel, EditorialFlexModule } from "typings/microserviceModels/content-flex-module";
import { RenderAbleContentItem } from "components/flexComponents/Content/factory/impl/items/RenderAbleContentItem";
import EditorialItemModel from "components/flexComponents/Content/factory/impl/items/EditorialItemModel";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";

export class DefaultEditorial extends EditorialBase {
  /* istanbul ignore next */
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate(props: ContentProps) {
    const queryParams = props.routeStore?.queryParams || {};
    const expandEditorialWithId = queryParams.expandEditorial === this.flexComponent.id;
    const editorialModel = this.flexComponent.model as EditorialFlexModule;

    const padding = editorialModel?.padding;
    const boxType = editorialModel?.boxType;
    const toggle = expandEditorialWithId ? "expanded" : editorialModel?.toggle;
    const classNameAttr = `${this.getEditorialItemClassName()}`;
    const { title: moduleTitle, subtitle: moduleSubtitle } = this.editorial;

    return (
      <div
        className={classNameAttr}
        id={this.flexComponent.id}
        data-fm={this.flexComponent.fmId}
        data-fm-title-id={this.flexComponent.fmTitleId}
      >
        <div className="EditorialModuleTitles">
          {moduleTitle && (
            <UitkSpacing margin={{ block: "one" }}>
              <UitkHeading level={2} size={500}>
                {moduleTitle}
              </UitkHeading>
            </UitkSpacing>
          )}
          {moduleSubtitle && (
            <UitkSpacing margin={{ block: "two" }}>
              <UitkSubheading level={3}>{moduleSubtitle}</UitkSubheading>
            </UitkSpacing>
          )}
        </div>
        <div>
          {this.editorial.items
            .filter((item: EditorialModel) => item.text || item.title)
            .map((item: EditorialModel) => {
              const imageToDisplay = item.media?.find((media) => media.mediaType === "Image" && !!media.mediaUrl);

              return this.getItem(
                new EditorialItemModel(
                  item.id,
                  item.text,
                  item.title,
                  item.subtitle,
                  this.editorial.uitkIconName,
                  editorialModel?.view,
                  toggle,
                  this.editorial.floatImage,
                  padding,
                  boxType,
                  imageToDisplay,
                  props.context,
                  editorialModel?.imageAspectRatio
                )
              );
            })}
        </div>
      </div>
    );
  }

  public getItem(model: EditorialItemModel): JSX.Element {
    return (
      <RenderAbleContentItem
        id={model.id}
        text={model.text}
        title={model.title}
        subtitle={model.subtitle}
        toggle={model.toggle}
        view={model.view || ""}
        key={`${this.contentPurpose}-${this.keyHelper.next()}`}
        padding={model.padding}
        boxType={model.boxType}
        media={model.media}
        context={model.context}
        imageAspectRatio={model.imageAspectRatio}
      />
    );
  }
}

export default DefaultEditorial;
